<div class="login-page vh-100 bg-secondary">
  <div class="container">
    <div class="row py-5">
      <div class="col-12 col-md-4 offset-md-4 text-center">
        <img class="d-block w-100" src="assets/images/logo.svg" alt="hello-one Enterprise">
      </div>

      <div class="col-12 col-md-6 offset-md-3 mt-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center">
              <h1 class="h4 text-uppercase">Passwort vergessen</h1>
            </div>

            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <app-form-group
                  [formControl]="this.form.controls.email"
                  type="email"
                  name="email"
                  label="E-Mail Adresse"
                  autocomplete="email"
                  [errorMessages]="{
                    required: 'Bitte geben Sie eine E-Mail Adresse ein',
                    email: 'Bitte geben Sie eine gültige E-Mail Adresse ein'
                  }"
                ></app-form-group>
              </div>

              <div class="row my-3">
                <div class="col-12">
                  <button [disabled]="form.invalid" class="btn btn-primary w-100" type="submit">Passwort Email
                    verschicken
                  </button>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12 d-flex justify-content-center">
                  <a class="btn" routerLink="/login">Zurück</a>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>
